/** @format */

import React from 'react'

import './style.css'

import { is_touch_device } from '../../utils'

export function ControlsHint() {
  return (
    <>
      {!is_touch_device() && (
        <div className="controls">
          <img src="/assets/arrow-keys.svg" alt="Keyboard controls" />
          <p>Keyboard controls</p>
        </div>
      )}

      {is_touch_device() && (
        <div className="controls">
          <img width="93" height="85" src="/assets/phone-tilt.svg" alt="Tilt" />
          <p style={{ marginBottom: '25%' }}>Tilt</p>
        </div>
      )}
    </>
  )
}
